'use strict'

var EventListenerOption = require('../lib/EventListenerOption.js');

/**
 * Auto loads next page of results when getting close to bottom of a scrollable area.
 * New results are appended to previous results and pagination is replaced with
 * pagination form the new page.
 *
 * Here is an example setup. All options are required except as marked below.
 *
 *
	var autoLoadPages = new AutoLoadPages({
		scrollableArea: window,
		resultsSelector: '.queryListing .listItems',
		paginationSelector: '.pagination',
		nextSelector: '.btn--next:not(.disabled)',
		loadWhenDistanceFromBottom: 200
	});
 *
 */

var Debouncer = require('./Debouncer.js');

function AutoLoadPages(opt) {
	opt.nextSelector = opt.nextSelector || '.next';
	opt.loadWhenDistanceFromBottom = opt.loadWhenDistanceFromBottom !== undefined ? opt.loadWhenDistanceFromBottom : 400;

	this.opt = opt;

	// Initial setup.
	this.setup();
}
AutoLoadPages.prototype.destroy = function() {
	// TODO Is this right? Why is it setting up addEventListener during destroy?
	if (this.loadNextIfNeededDebouncer !== undefined) {
		// Setup to check if next page needs to loaded when window scrolled or window resized
		var listOpts = EventListenerOption.get();
		this.scrollableArea.on('scroll', this.loadNextIfNeededDebouncer.run, listOpts);
		window.addEventListener('load', this.loadNextIfNeededDebouncer.run, listOpts);
		window.addEventListener('resize', this.loadNextIfNeededDebouncer.run, listOpts);
	}

}
AutoLoadPages.prototype.setup = function() {
	var opt = this.opt;

	// If setup previously then undo setup and redo
	this.destroy();

	var scrollableArea = typeof(opt.scrollableArea) === 'string' ? document.querySelector(opt.scrollableArea) : opt.scrollableArea;
	this.scrollableArea = scrollableArea;

	var resultsArea = document.querySelector(opt.resultsAreaSelector);
	var pagination = document.querySelector(opt.paginationSelector);

	if (pagination === null || resultsArea === null) {
		// Nothing to setup
		return;
	}

	pagination.classList.add('autoLoadPage--setup');
	
	var currentlyLoading = false;

	var loadNextIfNeededDebouncer = new Debouncer(function(e) {
		var scrollTop;
		var scrollHeight;
		if (scrollableArea === window) {
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			scrollHeight = window.innerHeight;
		} else {
			scrollTop = scrollableArea.scrollTop;
			scrollHeight = scrollableArea.clientHeight;
		}
				
		var distanceLeft = (resultsArea.offsetTop + resultsArea.offsetHeight) - scrollTop - scrollHeight;
		
		if (distanceLeft <= opt.loadWhenDistanceFromBottom) {
			// Near bottom of resultsArea, load next page.
			loadNextPage();
		}
	});
	this.loadNextIfNeededDebouncer = loadNextIfNeededDebouncer;

	var loadNextPage = function() {
		if (currentlyLoading || !pagination) {
			// Already loading or  no next page to load.
			return false;
		}

		var more = pagination.querySelector(opt.nextSelector);
		if (more === null) {
			return false;
		}

		var loadHref = more.getAttribute('href');
		if (loadHref === null || loadHref.length === 0) {
			return false;
		}

		// Stop multiple pages from loading at once
		currentlyLoading = true;

		// Seems new version of jQuery changes: /centpoint-web/insights.html?_=1466191391264&page=3
		//  to /centpoint-web/insights.html&page=3?_=1466191391265
		// 	so we remove the parameter to ensure we don't run into an issue
		loadHref = loadHref.replace(/&?_=[0-9]+/, '');
		loadHref = loadHref.replace(/\?&/, '?');
		
		pagination.classList.add('autoLoadPage--isLoading');


		var request = new XMLHttpRequest();

		request.open('GET', loadHref, true);
		request.setRequestHeader('Content-Type',  'text/xml');
		if (request.overrideMimeType) {
			request.overrideMimeType('text/xml');
		}
		request.onload = function () {
		    if (this.status >= 200 && this.status < 400) {
			var html = this.responseXML;
			if (!html) {
				var parser = new DOMParser();
				html = parser.parseFromString(this.responseText, 'text/html');
				if (!html) {
					console.error('Unable to create XML from response');
				}
			}

			pagination.classList.remove('autoLoadPage--isLoading');
			
			// Append after last result
			var newResults = html.querySelectorAll(opt.resultsSelector);
			var results = document.documentElement.querySelectorAll(opt.resultsSelector);
			var lastResult = results[results.length - 1];
			var insertBefore = lastResult.nextSibling;
			var parent = lastResult.parentNode;
			for (var childIndex=0; childIndex < newResults.length; childIndex++) {
				var child = document.importNode(newResults[childIndex], true);
				parent.insertBefore(child, insertBefore);
			}

			// Update pagination
			if (pagination !== null) {
				var newPagination = html.querySelector(opt.paginationSelector);
				if (newPagination) {
					newPagination = document.importNode(newPagination, true);
					pagination.parentNode.insertBefore(newPagination, pagination);
					pagination.parentNode.removeChild(pagination);
					pagination = newPagination;
					
					//pagination.outerHTML = newPagination.outerHTML;
					
					pagination.classList.add('autoLoadPage--setup');
					//pagination = newPagination;
					
					var more = pagination.querySelector(opt.nextSelector);
					if (more === null) {
						// Add class stating there is nothing left
						pagination.classList.add('autoLoadPage--noNext');
					}
				} else {
					// No more results
					pagination.parentNode.removeChild(pagination);
					pagination = null;
				}
			}

			// Set back so another page can load.
			currentlyLoading = false;

			// Check if even though we just loaded a page we need to load another one to fill the area.
			loadNextIfNeededDebouncer.runNow();

		    } else {
			// Response error
		    }
		};
		request.onerror = function() {
		    // Connection error
		};
		request.send();
	}

	// Setup to check if next page needs to loaded when window scrolled or window resized
	scrollableArea.addEventListener('scroll', this.loadNextIfNeededDebouncer.run);
	window.addEventListener('load', this.loadNextIfNeededDebouncer.run);
	window.addEventListener('resize', this.loadNextIfNeededDebouncer.run);
}

module.exports = AutoLoadPages;
